import { Navigate, useLocation } from '@tanstack/react-router';
import type { ReactElement, ReactNode } from 'react';

type DefaultGuardProps = { children: ReactElement | ReactElement[] };

export function DefaultGuard({ children }: DefaultGuardProps): ReactNode {
  const location = useLocation();

  return location.pathname === '/' ? (
    <Navigate to={'/purchase-planning'} />
  ) : (
    children
  );
}
